/**
 * Authentication utility functions
 */

import { refreshTokenService } from '../services/refreshTokenService';

/**
 * Check if error indicates 401 unauthorized and trigger logout
 * @param error - Error object from API call
 * @returns boolean - true if 401 was detected and logout was triggered
 */
export const checkAndHandle401 = (error: any): boolean => {
  // Check for 401 status code in error object
  if (error && typeof error === 'object') {
    // Check various possible locations for status code
    const statusCode = error.status || error.statusCode || error.status_code || 
                      error.response?.status || error.response?.statusCode || 
                      error.response?.status_code;
    
    if (statusCode === 401) {
      
      // Clear tokens from storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('is_new_user');
      localStorage.removeItem('session_info');
      
      // Reset refresh service state
      refreshTokenService.forceLogout();
      
      // Redirect to home page
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
      
      return true;
    }
  }
  
  return false;
};

/**
 * Wrapper for API calls that automatically handles 401 responses
 * @param apiCall - The API call function
 * @returns Promise with 401 handling
 */
export const with401Handling = async <T>(apiCall: () => Promise<T>): Promise<T> => {
  try {
    const response = await apiCall();
    return response;
  } catch (error: any) {
    // Check if the error indicates 401 unauthorized
    if (checkAndHandle401(error)) {
      throw new Error('Unauthorized - user logged out');
    }
    
    throw error;
  }
};
